// DEVELOPMENT MODE - Force restore console FIRST
import './restoreConsole';
// DEVELOPMENT MODE - Console enabled for debugging
// import './setupConsole'; // DISABLED FOR DEVELOPMENT
import './index.css';
// import './suppressConsole'; // DISABLED FOR DEVELOPMENT
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

// Disable React error overlay for cross-origin "Script error" messages
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    // Suppress React error overlay for generic "Script error"
    if (args[0]?.includes?.('Script error') || args[0]?.message?.includes?.('Script error')) {
      return;
    }
    originalError.apply(console, args);
  };
}

// FORCE console output - these MUST appear
window.console.log('🔥🔥🔥 [INDEX] CONSOLE IS WORKING! 🔥🔥🔥');
window.console.error('🔥🔥🔥 [INDEX] ERROR LOG TEST 🔥🔥🔥');
window.console.warn('🔥🔥🔥 [INDEX] WARN LOG TEST 🔥🔥🔥');
window.console.info('🔥🔥🔥 [INDEX] INFO LOG TEST 🔥🔥🔥');

// Console logs after all imports
console.log('🔥 [INDEX] Console restored!');
console.log('🔥 [INDEX] App imported:', App);
console.log('🔥 [INDEX] Creating React root...');

const root = ReactDOM.createRoot(document.getElementById('root'));

console.log('🔥 [INDEX] Rendering app...');
// DEVELOPMENT: StrictMode disabled to prevent double renders and console suppression
root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

console.log('🔥 [INDEX] App rendered!');